import { QueryClient } from '@tanstack/react-query'

import { BrandItemViewModel, MenuViewModel } from '@/types/api'

import fetchRequest from '@/app/_utils/fetch-request'
import { QueryKeys } from '@/app/_utils/react-query'

export const prefetchLayoutMenu = (queryClient: QueryClient) => {
    return queryClient.prefetchQuery({
        queryKey: QueryKeys.Layout.LayoutMenu,
        queryFn: async () => {
            const data: MenuViewModel = await fetchRequest({
                endpoint: `/layout/menu`,
                method: 'GET',
                serviceName: 'ntl',
                isServerSideRequest: true,
            })

            // Recursively remove `logoUrl` from the data
            const removeLogoUrl = (menu: MenuViewModel): MenuViewModel => {
                const removeLogoFromBrands = (brands: BrandItemViewModel[] | null | undefined) =>
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    brands?.map(({ logoUrl, ...rest }) => rest)

                return {
                    ...menu,
                    brand: menu.brand
                        ? {
                              topBrands: removeLogoFromBrands(menu.brand.topBrands),
                          }
                        : undefined,
                }
            }

            return removeLogoUrl(data)
        },
    })
}
